/* screens/crm/LeadArchiveDrawer.jsx — архив лидов воронки + восстановление. */
import React from 'react';
import { Drawer } from '../../components/ui/Drawer.jsx';
import { Button } from '../../components/ui/Button.jsx';
import { Spinner } from '../../components/ui/Spinner.jsx';
import { useToast } from '../../app/providers/ToastProvider.jsx';
import { fmt } from '../../lib/format.js';
import * as crm from '../../lib/api/crm.js';

const { useState, useEffect, useCallback } = React;

function LeadArchiveDrawer({ pipelineId, onClose, onRestored }) {
  const toast = useToast();
  const [rows, setRows] = useState(null);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await crm.listLeads({ pipeline: pipelineId, archived: 1, limit: 200 });
      setRows(r.results || []);
    } catch (e) {
      toast.show(e?.detail || 'Не удалось загрузить архив.', 'danger');
      setRows([]);
    }
  }, [pipelineId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { load(); }, [load]);

  const restore = async (lead) => {
    setBusyId(lead.id);
    try {
      await crm.restoreLead(lead.id);
      toast.show('Лид восстановлен', 'accent');
      setRows((rs) => (rs || []).filter((r) => r.id !== lead.id));
      onRestored && onRestored();
    } catch (e) {
      toast.show(e?.detail || 'Не удалось восстановить.', 'danger');
    } finally {
      setBusyId(null);
    }
  };

  return (
    <Drawer open onClose={onClose} size="md" title="Архив лидов">
      {rows == null ? (
        <div className="state state--loading"><Spinner size="lg" label="Загрузка…" /></div>
      ) : rows.length === 0 ? (
        <p className="text-dim">В архиве пусто.</p>
      ) : (
        <div className="stack stack-8">
          {rows.map((lead) => (
            <div key={lead.id} className="crm-archive-row">
              <div className="grow" style={{ minWidth: 0 }}>
                <div className="crm-card__title truncate">{lead.client}</div>
                <div className="crm-card__sub truncate">
                  {[lead.company, lead.stage_name].filter(Boolean).join(' · ')}
                </div>
              </div>
              {lead.value != null && <span className="num crm-card__value">{fmt.money(lead.value)}</span>}
              <Button size="sm" variant="secondary" iconLeft="refresh"
                loading={busyId === lead.id} onClick={() => restore(lead)}>Восстановить</Button>
            </div>
          ))}
        </div>
      )}
    </Drawer>
  );
}

export { LeadArchiveDrawer };
